import React, {useEffect, useRef} from "react";

export const CustomNodeDescription = (props) => {
    let {node, updateBlockDescription, state} = props;

    const prevOptions = useRef(node.extras.options);

    useEffect(() => {
       if (JSON.stringify(prevOptions.current) !== JSON.stringify(node.extras.options)) {
            updateBlockDescription(node);
        }
        prevOptions.current = node.extras.options;
    }, [node.extras.options, updateBlockDescription]);

    function getBlockDescription() {
        let nodeDescription;
        if (state.blockDescription !== undefined && Object.keys(state.blockDescription).length > 0) {
            nodeDescription = state.blockDescription
        } else if (node.blockDescription !== undefined && Object.keys(node.blockDescription).length > 0) {
            nodeDescription = node.blockDescription
        }
        return (nodeDescription)
    }

    return (
        <span className="node-name">
            {`Block Type: ${node.title}`}
            <br/>
            {getBlockDescription() &&
                (Object.entries(getBlockDescription()).map(([key, value]) => (
                    <React.Fragment key={key}>
                        {key !== '' && `${key}: `}
                        {value}
                        <br/>
                    </React.Fragment>
                )))
            }
        </span>
    )
}